export const leads = {
  'lead.title': 'Leads',
  'lead.subtitle': 'Patient onboarding before the chart becomes active',
  'lead.tableLabel': 'Patient leads',
  'lead.loading': 'Loading leads',
  'lead.loadFailed': 'Leads could not be loaded.',
  'lead.retry': 'Retry',
  'lead.empty': 'No leads yet',
  'lead.emptyDetail': 'Create a lead when a new patient first contacts the clinic.',
  'lead.publicEntryTitle': 'Public patient onboarding',
  'lead.publicEntryDetail': 'Share this general page with patients who are registering themselves.',
  'lead.publicEntryOpen': 'Open public onboarding',
  'lead.columnPatient': 'Patient',
  'lead.columnCode': 'Lead code',
  'lead.columnContact': 'Contact',
  'lead.columnSource': 'Source',
  'lead.columnEntry': 'Entry',
  'lead.columnAcquisition': 'Acquisition',
  'lead.columnResponsible': 'Curator',
  'lead.columnStatus': 'Status',
  'lead.columnCreated': 'Created',
  'lead.columnExpires': 'Link expires',
  'lead.columnActions': 'Actions',
  'lead.statusIssued': 'Waiting for patient',
  'lead.statusSubmitted': 'Submitted',
  'lead.statusRevoked': 'Revoked',
  'lead.sourcePhone': 'Phone',
  'lead.sourceEmail': 'Email',
  'lead.sourceMessenger': 'Messenger',
  'lead.sourceWebsite': 'Website',
  'lead.sourceTelegram': 'Telegram',
  'lead.sourceReferral': 'Referral',
  'lead.sourceOther': 'Other',
  'lead.entryInvited': 'Private invitation',
  'lead.entryPublic': 'Public page',
  'lead.newTitle': 'New lead',
  'lead.newDetail': 'Create a provisional patient and issue a private onboarding link.',
  'lead.language': 'Preferred language',
  'lead.country': 'Country of residence',
  'lead.source': 'Source channel',
  'lead.comment': 'Short comment',
  'lead.curator': 'Responsible doctor or coordinator',
  'lead.protocol': 'Onboarding protocol',
  'lead.expiresAt': 'Link expiry',
  'lead.create': 'Create lead',
  'lead.creating': 'Creating…',
  'lead.selectionRequired': 'Choose a curator and onboarding protocol.',
  'lead.expiryRequired': 'Choose a future link expiry.',
  'lead.optionsLoading': 'Loading curators and protocols…',
  'lead.optionsFailed': 'Curators or onboarding protocols could not be loaded.',
  'lead.noProtocols': 'No published patient-onboarding protocol is available.',
  'lead.saveFailed': 'The lead could not be created.',
  'lead.idempotencyConflict': 'This creation attempt was already used for different lead data.',
  'lead.createdTitle': 'Lead created',
  'lead.createdDetail': 'Copy this private link now. Core never stores the raw link.',
  'lead.link': 'Patient onboarding link',
  'lead.copyLink': 'Copy link',
  'lead.linkCopied': 'Link copied',
  'lead.copyFailed': 'The link could not be copied. Select it and copy it manually.',
  'lead.openLink': 'Open onboarding',
  'lead.rotateNamed': 'Issue a new link for {name}',
  'lead.claim': 'Claim',
  'lead.claimNamed': 'Claim {name}',
  'lead.claiming': 'Claiming…',
  'lead.claimFailed': 'The lead could not be claimed. It may already belong to someone else.',
  'lead.claimSelected': 'Claim {count} selected',
  'lead.claimedCount': '{count} leads were claimed.',
  'lead.claimedBefore': '{count} leads were claimed before that.',
  'lead.rotateTitle': 'Issue a new onboarding link',
  'lead.rotateDetail': 'The previous link stops working immediately.',
  'lead.rotate': 'Issue new link',
  'lead.rotating': 'Issuing…',
  'lead.rotateFailed': 'A new link could not be issued.',
  'lead.notRotatable': 'This lead is no longer waiting for onboarding.',
  'lead.discardTitle': 'Discard this lead draft?',
  'lead.discardDetail': 'The information entered here has not been saved.',
  'lead.keepEditing': 'Keep editing',
  'lead.discard': 'Discard',
  'lead.submissionsTitle': 'Patient onboarding',
  'lead.submissionsDetail': 'Patient-authored intake evidence stored with the protocol version that was completed.',
  'lead.submissionsLoading': 'Loading onboarding responses',
  'lead.submissionsFailed': 'Onboarding responses could not be loaded.',
  'lead.submissionsEmpty': 'No patient onboarding response is recorded.',
  'lead.answeredBy': 'Answered by',
  'lead.authoredAt': 'Submitted',
  'lead.authorPatient': 'Patient',
  'lead.authorRepresentative': 'Representative',
  'lead.schemaUnavailable': 'This historical protocol cannot be displayed by this client.',
  'lead.valueYes': 'Yes',
  'lead.valueNo': 'No',
  'lead.representativesTitle': 'Representatives',
  'lead.representativesLoading': 'Loading representatives',
  'lead.representativesFailed': 'Representatives could not be loaded.',
  'lead.representativesEmpty': 'No representative is recorded.',
  'lead.representativeParent': 'Parent',
  'lead.representativeGuardian': 'Guardian',
  'lead.representativeAuthorized': 'Authorized person',
  'lead.representativeOther': 'Other',
  'lead.verificationSelfDeclared': 'Self-declared',
  'lead.verificationVerified': 'Verified',
  'lead.verificationRevoked': 'Revoked',
  'lead.representativeRelationship': 'Relationship:',
  'lead.authorityScope': 'Authority:',
  'lead.authoritySubmitOnboarding': 'Submit patient onboarding',
  'lead.areaNavigation': 'Leads sections',
  'lead.sectionLeads': 'Leads',
  'lead.sectionLeadsDetail': 'Patient requests and onboarding',
  'lead.sectionPartners': 'Referral partners',
  'lead.sectionPartnersDetail': 'Sources, links and rewards',
  'referralPartner.title': 'Referral partners',
  'referralPartner.subtitle': 'Legal identities enrolled in the clinic referral program',
  'referralPartner.loading': 'Loading referral partners',
  'referralPartner.loadFailed': 'Referral partners could not be loaded.',
  'referralPartner.tableLabel': 'Referral partner register',
  'referralPartner.empty': 'No referral partners yet',
  'referralPartner.emptyDetail': 'Enroll an existing legal identity to issue a private referral link.',
  'referralPartner.columnName': 'Partner',
  'referralPartner.columnKind': 'Kind',
  'referralPartner.columnStatus': 'Status',
  'referralPartner.columnValidity': 'Validity',
  'referralPartner.columnAgreement': 'Agreement',
  'referralPartner.columnLink': 'Personal link',
  'referralPartner.columnVerified': 'Verified leads',
  'referralPartner.columnCompleted': 'Completed',
  'referralPartner.columnPoints': 'Available points',
  'referralPartner.columnMoney': 'Approved money',
  'referralPartner.columnActions': 'Actions',
  'referralPartner.openNamed': 'Open {name}',
  'referralPartner.kindOrganization': 'Organization',
  'referralPartner.kindIndividual': 'Individual',
  'referralPartner.status.active': 'Active',
  'referralPartner.status.suspended': 'Suspended',
  'referralPartner.status.closed': 'Closed',
  'referralPartner.panelEyebrow': 'Referral partner',
  'referralPartner.edit': 'Edit',
  'referralPartner.editIdentity': 'Edit legal identity',
  'referralPartner.legalEntity': 'Legal identity',
  'referralPartner.selectLegalEntity': 'Select a legal identity',
  'referralPartner.identityManagedSeparately': 'Names, tax details, address and contacts are edited in Legal identities.',
  'referralPartner.archive': 'Archive',
  'referralPartner.restore': 'Restore',
  'referralPartner.contactTitle': 'Legal identity details',
  'referralPartner.kind': 'Legal identity kind',
  'referralPartner.taxId': 'Tax identifier',
  'referralPartner.taxType': 'Tax identifier type',
  'referralPartner.phone': 'Phone',
  'referralPartner.email': 'Email',
  'referralPartner.website': 'Website',
  'referralPartner.address': 'Address',
  'referralPartner.addressLine2': 'Address line 2',
  'referralPartner.city': 'City',
  'referralPartner.postalCode': 'Postal code',
  'referralPartner.country': 'Country',
  'referralPartner.linkTitle': 'Private referral link',
  'referralPartner.link': 'Referral link',
  'referralPartner.linkActive': 'Active',
  'referralPartner.linkInactive': 'Revoked or not issued',
  'referralPartner.copyLink': 'Copy referral link',
  'referralPartner.openLink': 'Open referral link',
  'referralPartner.copied': 'Referral link copied.',
  'referralPartner.copyFailed': 'The link could not be copied. Select it and copy it manually.',
  'referralPartner.rotate': 'Rotate link',
  'referralPartner.revoke': 'Revoke link',
  'referralPartner.performanceTitle': 'Attribution and balances',
  'referralPartner.pointsAvailable': 'Available points',
  'referralPartner.pointsPending': 'Pending points',
  'referralPartner.pointsRedeemed': 'Redeemed points',
  'referralPartner.pointsReversed': 'Reversed points',
  'referralPartner.balancePending': 'Pending',
  'referralPartner.balanceApproved': 'Approved',
  'referralPartner.balancePaid': 'Paid',
  'referralPartner.balanceReversed': 'Reversed',
  'referralPartner.agreementsTitle': 'Agreement history',
  'referralPartner.agreementsEmpty': 'No agreement is recorded.',
  'referralPartner.agreementCode': 'Agreement code',
  'referralPartner.agreementStatus': 'Agreement status',
  'referralPartner.addAgreement': 'Add agreement',
  'referralPartner.rulesTitle': 'Reward rules',
  'referralPartner.rulesEmpty': 'No reward rule is active.',
  'referralPartner.trigger.verified_lead': 'Verified lead',
  'referralPartner.trigger.onboarding_submitted': 'Completed onboarding',
  'referralPartner.triggerLabel': 'Trigger',
  'referralPartner.valueKind': 'Reward kind',
  'referralPartner.valueKindPoints': 'Points',
  'referralPartner.valueKindMoney': 'Money',
  'referralPartner.rewardPoints': 'Points: {amount}',
  'referralPartner.amount': 'Amount',
  'referralPartner.currency': 'Currency',
  'referralPartner.effectiveFrom': 'Effective from',
  'referralPartner.effectiveTo': 'Effective to',
  'referralPartner.ruleEnabled': 'Enabled',
  'referralPartner.ruleDisabled': 'Disabled',
  'referralPartner.editRule': 'Edit rule',
  'referralPartner.saveRule': 'Save new revision',
  'referralPartner.addRule': 'Add rule',
  'referralPartner.rewardsTitle': 'Reward ledger',
  'referralPartner.rewardsEmpty': 'No rewards have accrued.',
  'referralPartner.rewardState.pending': 'Pending',
  'referralPartner.rewardState.approved': 'Approved',
  'referralPartner.rewardState.rejected': 'Rejected',
  'referralPartner.rewardState.paid': 'Paid',
  'referralPartner.rewardState.reversed': 'Reversed',
  'referralPartner.approve': 'Approve',
  'referralPartner.reject': 'Reject',
  'referralPartner.markPaid': 'Mark paid',
  'referralPartner.reverse': 'Reverse',
  'referralPartner.failure.invalid': 'Check the entered values and try again.',
  'referralPartner.failure.conflict': 'This record changed or the action is no longer valid. The latest data has been loaded; your entered values are still here.',
  'referralPartner.failure.forbidden': 'You do not have permission to perform this action.',
  'referralPartner.failure.unavailable': 'The referral service is unavailable. Try again without closing this panel.',
  'referralPartner.editTitle': 'Edit referral partner',
  'referralPartner.createTitle': 'New referral partner',
  'referralPartner.legalName': 'Legal name',
  'referralPartner.statusLabel': 'Program status',
  'referralPartner.statusHistoryNote': 'Suspending or closing stops new attribution. Existing attribution and reward history remains unchanged.',
  'referralPartner.validFrom': 'Valid from',
  'referralPartner.validTo': 'Valid to',
  'referralPartner.comment': 'Comment',
  'referralPartner.save': 'Save',
  'referralPartner.saving': 'Saving…',
  'referralPartner.cancel': 'Cancel',
  'referralPartner.confirm.archive': 'Archive this referral partner?',
  'referralPartner.confirm.restore': 'Restore this referral partner?',
  'referralPartner.confirm.rotate': 'Rotate this private referral link?',
  'referralPartner.confirm.revoke': 'Revoke this private referral link?',
  'referralPartner.confirm.reward': 'Confirm this reward transition?',
  'referralPartner.confirmDescription.archive': 'The active link will be revoked. Existing attributions and reward history remain unchanged.',
  'referralPartner.confirmDescription.restore': 'Historical evidence remains unchanged. Rotate a link after restoring to issue a new active link.',
  'referralPartner.confirmDescription.rotate': 'The current link will stop accepting new attributions. Existing attribution and reward history remains unchanged.',
  'referralPartner.confirmDescription.revoke': 'The link will stop accepting new attributions. Existing attribution and reward history remains unchanged.',
  'referralPartner.confirmDescription.reward': 'This appends a ledger event; it does not rewrite prior reward history.',
  'referralPartner.reason': 'Reason',
  'referralPartner.confirm': 'Confirm',
  'referralPartner.confirmedReason': 'Confirmed in the referral partner register.',
  'referralPartner.agreementState.active': 'Active',
  'referralPartner.agreementState.closed': 'Closed',
  'referralPartner.validityOpen': 'open',
} as const
